/* eslint-disable max-len */
const React = require('react');

const InPersonPaymentsPoint = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="37" height="40" viewBox="0 0 37 40">
    <g fill="none" fillRule="evenodd" stroke="#009EE3">
      <path strokeWidth="1.6" d="M0.8 5.8H36.199999999999996V28.2H0.8z" />
      <path fill="#FFF" strokeWidth="1.6" d="M7.8 19.8H30.2V36.2H7.8z" />
      <path fill="#FFF" strokeWidth="1.6" d="M15.8 27.8H22.200000000000003V31.2H15.8z" />
      <path strokeLinecap="square" strokeWidth="2" d="M24.5 10.5L30.5 10.5M8.5 14.5L30.5 14.5" />
    </g>
  </svg>
);

module.exports = InPersonPaymentsPoint;
